<script>
  // # # # # # # # # # # # # #
  //
  //  Article page
  //
  // # # # # # # # # # # # # #

  // *** IMPORT
  import { fade } from "svelte/transition";
  import get from "lodash/get";

  // *** COMPONENTS
  import Slideshow from "../Components/Slideshow.svelte";
  import Taglist from "../Components/Taglist.svelte";

  // *** PROPS
  export let slug = "";
  export let endpoint = "";
  export let architecture = false;
  export let gallery = false;

  // *** VARIABLES
  let title = "";

  // *** FUNCTIONS
  async function loadData() {
    const res = await fetch(endpoint + slug + ".json");
    const post = await res.json();
    window.scrollTo(0, 0);
    title = get(post, "header.title", "undefined title");
    return post;
  }

  const post = loadData();
</script>

<style lang="scss">
  @import "../_variables.scss";

  .single {
    $block: &;
    color: $black;
    overflow: hidden;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    position: relative;
    display: block;

    @include screen-size("small") {
      overflow: auto;
      height: auto;
    }

    &__text {
      height: 100%;
      width: 50%;
      float: left;
      padding-bottom: $bottom-space;
      z-index: 100;
      background: $white;
      overflow: hidden;
      position: relative;
      padding-top: 80px;
      padding-left: $main-margin;
      padding-right: $main-margin;
      display: flex;
      flex-wrap: wrap;
      position: relative;

      @include screen-size("small") {
        float: right;
        width: 100%;
        left: 0;
        position: static;
        height: auto;
        margin-bottom: 0px;
        padding-top: 0px;
        padding-bottom: 0;
      }
    }

    &__body {
      display: flex;
      flex-flow: row;
      height: 100%;
      @include screen-size("small") {
        flex-wrap: wrap;
      }
    }

    &__column {
      height: calc(100% - 70px);
      width: 100%;
      padding-right: $main-margin;

      p:first-child {
        margin-top: 0;
      }

      &--left {
        font-size: $font-size-medium;
        font-weight: 100;
        width: 40%;
        @include screen-size("small") {
          width: 100%;
        }
      }

      &--right {
        font-family: $serif-stack;
        font-size: $font-size-medium;
        font-weight: 100;
        width: 60%;
        overflow: scroll;
        line-height: 1.3em;
        padding-bottom: 40px;

        @include hide-scroll;

        a {
          color: currentColor;
          border-bottom: 1px solid $black;

          @include normal-hover-state;

          &:hover {
            border-bottom: none;
          }
        }
        @include screen-size("small") {
          width: 100%;
          max-width: 50ch;
        }
      }
    }

    &__blur {
      position: absolute;
      width: 60%;
      height: 80px;
      background: $white;
      box-shadow: -7px -30px 40px $white;
      bottom: 0;
      left: 40%;
      @include screen-size("small") {
        display: none;
      }
    }

    &__intro {
      font-size: $font-size-large;
      font-family: $serif-stack;
      margin-bottom: $main-margin;
    }

    &__title {
      font-size: $font-size-large;
      font-family: $sans-stack;
      border-bottom: none;
      color: $black;
      margin-bottom: 1em;
      width: 100%;
      font-weight: 500;

      @include screen-size("small") {
        margin-bottom: 0.5em;
      }
    }

    &__slideshow {
      height: 100%;
      width: 50%;
      float: left;
      cursor: pointer;
      overflow: hidden;
      position: relative;

      @include screen-size("small") {
        float: right;
        width: 100%;
        height: 400px;
        left: 0;
        position: static;
        margin-bottom: 20px;
      }
    }

    &.architecture {
      #{ $block }__text {
        float: left;
        border-right: 5px solid white;
      }

      #{ $block }__slideshow {
        float: right;
      }
    }

    &.gallery {
      #{ $block }__text {
        float: right;
        border-left: 5px solid white;
      }

      #{ $block }__slideshow {
        float: left;
      }
    }
  }
</style>

<svelte:head>
  <title>{title} | COMPLETE WORKS</title>
</svelte:head>

{#await post then post}

  <div class="single" class:architecture class:gallery in:fade>

    <!-- {# SLIDESHOW #} -->
    <div class="single__slideshow">
      <Slideshow slides={post.header.slideshow} />
    </div>

    <!-- {# TEXT #} -->
    <div class="single__text">

      <!-- {# TITLE #} -->
      <h2 class="single__title">{post.header.title}</h2>

      <div class="single__body">

        <div class="single__column single__column--left">
          <!-- {# INTRO #} -->
          {#if post.header.description}
            <div class="single__intro">
              {@html post.header.description}
            </div>
          {/if}

          <!-- {# TAGS #} -->
          <Taglist item={post} />
        </div>

        <!-- {# BODY TEXT #} -->
        <div class="single__column single__column--right">
          {#if post.content}
            {@html post.content}
          {/if}
        </div>

        <div class="single__blur" />

      </div>
    </div>

  </div>

{/await}
